import { IUserBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const createProfileConfirmationsService = async (
  userId: string,
): Promise<IUserBase> => {
  const { data } = await jhsfBookingsApi.post<IUserBase>(
    `/users/${userId}/profile-confirmation`,
  );

  return data;
};

export default createProfileConfirmationsService;
